import { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";
import { useLang } from "../../context/LangContext";

export const PricingExtras = () => {
  const { t } = useLang();
  const { faq, compare } = t.pricing;
  const [open, setOpen] = useState(0);

  return (
    <div className="mt-20 grid lg:grid-cols-2 gap-12 lg:gap-16">
      <div data-testid="pricing-compare">
        <h3 className="font-display font-bold text-2xl text-[#0F172A]">{compare.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">{compare.intro}</p>
        <div className="mt-6 rounded-md border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#0A0F1A] text-white">
                <th className="text-left px-4 py-3 font-semibold"></th>
                <th className="px-4 py-3 font-semibold">{compare.base}</th>
                <th className="px-4 py-3 font-semibold">{compare.pro}</th>
                <th className="px-4 py-3 font-semibold text-emerald-400">{compare.fascicolo}</th>
              </tr>
            </thead>
            <tbody>
              {compare.rows.map((r, i) => (
                <tr key={r.f} className={i % 2 ? "bg-[#F8F9FA]" : "bg-white"}>
                  <td className="px-4 py-3 text-slate-600">{r.f}</td>
                  <td className="px-4 py-3 text-center font-mono-tech text-slate-700">{r.b}</td>
                  <td className="px-4 py-3 text-center font-mono-tech text-slate-700">{r.p}</td>
                  <td className="px-4 py-3 text-center font-mono-tech font-semibold text-emerald-700">{r.x}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div data-testid="pricing-faq">
        <h3 className="font-display font-bold text-2xl text-[#0F172A]">{faq.title}</h3>
        <div className="mt-6 divide-y divide-slate-200 border-y border-slate-200">
          {faq.items.map((item, i) => (
            <div key={item.q}>
              <button onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 py-4 text-left font-semibold text-[15px] text-[#0F172A] hover:text-emerald-700 transition-colors"
                data-testid={`faq-question-${i}`}>
                {item.q}
                <CaretDown size={16} className={`shrink-0 transition-transform ${open === i ? "rotate-180 text-emerald-600" : "text-slate-400"}`} />
              </button>
              {open === i && (
                <p className="pb-5 text-sm leading-relaxed text-slate-600" data-testid={`faq-answer-${i}`}>{item.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
